import React from "react";
import { Spinner } from "@fluentui/react-components";
import { Contact } from "../components/contact/ContactSection";
import { Hero } from "../components/hero/Hero";
import { Services } from "../components/services/Services";
import { Page } from "./Page";
import { useQuery } from "@apollo/client/react";
import { GET_HERO } from "../graphql/queries";
import { Error } from "./Error";
import { CalloutSection } from "../components/imageHighlight/ImageHighlight";
import { TextImage } from "../components/textImage/TextImage";
import { TextImageAlt } from "../components/textImage/TextImageAlt";
import { KeyHighlights } from "../components/keyHighlights/KeyHighlights";
import { Subscriptions } from "../components/subscriptions/Subscriptions";
import { t } from "../i18n/i18n";
import { useCmsLocale } from "../i18n/cmsLocale";

export const Start = () => {
  const locale = useCmsLocale();
  const { data, loading, error } = useQuery(GET_HERO, { variables: { locale } });
  if (loading) return <Spinner style={{ marginTop: "30vh" }} size="huge" />;
  if (error || !data?.heroSection)
    return (
      <Error error={error ? error.message : t("PageLoadError")} />
    );

  return (
    <Page>
      <Hero data={data.heroSection} />
      <Services />
      <CalloutSection />
      <TextImage />
      <KeyHighlights />
      <TextImageAlt />
      <Subscriptions />
      <Contact /> 
    </Page>
  );
};
